/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import { Flex, Box, Heading, Text, Hide } from '@qga/roo-ui/components';
import { Inclusion, Offer } from 'types/property';
import { Flag } from './primitives';
import { createValueAddsObj } from './OfferDetails.helper';
import useGlobalInclusions from 'hooks/optimizely/useGlobalInclusions';
import keyBy from 'lodash/keyBy';
import OfferDetailsTooltip from './OfferDetailsTooltip';
import OfferDetailsModal from './OfferDetailsModal';
import { ORDERED_INCLUSIONS_WHITELIST } from './constants';

interface OfferDetailsProps {
  offer: Offer;
}

const OfferDetails: React.FC<OfferDetailsProps> = memo(({ offer }) => {
  const { inclusions, description: offerDescription, name: offerName, valueAdds = [] } = offer;
  const { isGlobalInclusions } = useGlobalInclusions();
  const inclusionsByKey = keyBy(inclusions, 'code');
  const orderedInclusions = isGlobalInclusions
    ? inclusions
    : ORDERED_INCLUSIONS_WHITELIST.reduce((accum, { code, icon }) => {
        const inclusion = inclusionsByKey[code];
        if (!inclusion) return accum;
        return [...accum, { ...inclusion, icon }];
      }, [] as Inclusion[]);
  const valueAddsAndInclusions = valueAdds ? createValueAddsObj(valueAdds).concat(orderedInclusions) : orderedInclusions;

  return (
    <Flex flexDirection="column" data-testid="offer-details">
      <Heading.h3 display="block" mb={0} fontSize="md" lineHeight="normal">
        {offerName}
      </Heading.h3>
      <Box height="auto" color="greys.charcoal">
        {valueAddsAndInclusions.map(({ icon, description }, i) => (
          <Box key={i} data-testid="internet">
            <Flag icon={icon} color="greys.charcoal">
              <Text fontSize="16px" fontWeight={icon === 'welcomeGift' ? 'bold' : 'normal'}>
                {description}
              </Text>
            </Flag>
          </Box>
        ))}
        <Box pt={2}>
          <Hide sm xs>
            <OfferDetailsTooltip offerDescription={offerDescription} offerName={offerName} />
          </Hide>
        </Box>
        <Hide md lg>
          <OfferDetailsModal offerDescription={offerDescription} offerName={offerName} />
        </Hide>
      </Box>
    </Flex>
  );
});

export default OfferDetails;
